import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NbRedirectComponent } from './nb-redirect.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    NbRedirectComponent
  ],
  exports: [
    NbRedirectComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class NbRedirectModule { }
